import { ApiResult } from '@synergy/api';
import { PaginatedResponse } from '@synergy/api';
import { request, safeRequest } from '@synergy/api';

import { SalesOrder } from './models/salesOrder';

export class SalesOrdersApi {
    constructor(protected baseUrl: string) {}

    public get(id: number): Promise<ApiResult<SalesOrder>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/sales-orders/${id}`),
            response => SalesOrder.fromPlainObject(response.data)
        );
    }

    public post(salesOrder: SalesOrder): Promise<ApiResult<SalesOrder>> {
        return safeRequest(
            () =>
                request.post(`${this.baseUrl}/sales-orders`, salesOrder, {
                    params: { isSync: true },
                }),
            response => SalesOrder.fromPlainObject(response.data)
        );
    }

    public copySalesOrder(id: number): Promise<ApiResult<SalesOrder>> {
        return safeRequest(
            () =>
                request.post(
                    `${this.baseUrl}/sales-orders/${id}/copy`,
                    {},
                    {
                        params: { isSync: true },
                    }
                ),
            response => response.data
        );
    }

    public patch(id: number, salesOrder: SalesOrder): Promise<ApiResult<SalesOrder>> {
        return safeRequest(
            () => request.patch(`${this.baseUrl}/sales-orders/${id}`, salesOrder),
            response => SalesOrder.fromPlainObject(response.data)
        );
    }

    public cget(params?: URLSearchParams): Promise<ApiResult<PaginatedResponse<SalesOrder>>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/sales-orders`, { params }),
            response => {
                response.data.items = response.data.items.map(SalesOrder.fromPlainObject);
                return response.data;
            }
        );
    }

    public delete(id: number): Promise<ApiResult<null>> {
        return safeRequest(
            () => request.delete(`${this.baseUrl}/sales-orders/${id}`, { params: { isSync: true } }),
            () => null
        );
    }

    public export(params: URLSearchParams): Promise<ApiResult<Blob>> {
        const exportFields = [
            'number',
            'status',
            'type',
            'customerAccount.name',
            'customerContact.fullName',
            'responsibleContact.fullName',
            'createdAt',
        ];
        params.append('fields', exportFields.join(','));
        return safeRequest(
            () => request.get(`${this.baseUrl}/sales-orders.csv`, { params, responseType: 'blob' }),
            response => response.data
        );
    }
}
